module.exports = __webpack_public_path__ + "static/media/shop-pattern.39a3aca9.svg";